export class UserPrivacy {
    constructor(
        public showWorkPhoneNumber: boolean,
        public showMobilePhoneNumber: boolean,
        public showRoomNumber: boolean
    ) { }
}